import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import NavLink from '../NavLink'

const StyledLink = styled(NavLink)`
  padding: ${themeGet('space.2')}px 0;
  font-size: ${themeGet('fontSizes.1')}px;
  font-weight: 400;

  &:hover {
    text-decoration: none;
    filter: brightness(85%);
  }
`

function DropdownItem ({ className, label, iconName, color, onClick }) {
  return (
    <StyledLink
      m={3}
      label={label}
      iconName={iconName}
      color={color}
      onClick={onClick}
    />
  )
}

DropdownItem.displayName = 'DropdownItem'

DropdownItem.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  iconName: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func
}

DropdownItem.defaultProps = {
  className: ''
}

export default memo(DropdownItem)
